export const FLOORS = {
  a: '1',
  b: '2',
  c: '3',
  d: '4+',
}

export const AREA = {
  a: '0-50',
  b: '50-100',
  c: '100-250',
  d: '250+',
}
